import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AppInsightsService } from 'src/app/app-services/app-insights-service';
import { QueryParamsService, ValidQueryParams } from 'src/app/app-services/query-params-service';
import { UserDataService } from 'src/app/app-services/user-data-service';

@Component({
  selector: 'app-mental-health-condition',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './mental-health-condition.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentalHealthConditionComponent implements OnInit {
  queryString: string = '';
  constructor(
    private router: Router,
    private logger: AppInsightsService,
    private userDataService: UserDataService,
    private queryParamsService: QueryParamsService,
  ) {}
  ngOnInit() {
    this.queryString = this.queryParamsService.getQueryParam(ValidQueryParams.from) ?? '';
  }

  onTileClick(eventName: string, target: string, setData: any = null) {
    this.logger.TrackEvent(eventName, { from: this.queryString });
    if (setData) {
      this.userDataService.setData(setData.key, setData.value);
    }
    this.router.navigate([target]);
  }
}
